<template lang="pug">
  div(style="height: 400px")
    ScanBarcode(v-show="false" v-on:setBarcode="getBarcode")
    div.with-child-centered(v-if="reviewEmployee === undefined")
      h4 覆核人員請刷條碼
    div.with-child-centered(v-else)
      h4 覆核人員
      h4 
        strong {{ reviewEmployee.last_name }}{{ reviewEmployee.first_name }}
      button.btn.btn-lg.confirm-button(@click="confirmRx") 確認覆核
</template>

<script>
import ScanBarcode from './ScanBarcode';

export default {
  name: 'RxCheckBarcode',
  components: {
    ScanBarcode,
  },
  data() {
    return {
      reviewEmployee: undefined,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    confirmRx() {
      this.$emit('confirmRx', this.reviewEmployee);
    },
    getBarcode(val) {
      this.instance.get('/api/user/', {
        params: {
          barcode: val,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          const reviewEmployee = res.data.results[0];
          if (reviewEmployee.id === this.$store.state.user.user.id) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '自身無法覆核，請找其他人員進行覆核',
            });
          } else if (reviewEmployee.task_privilege.check) {
            // okay
            this.reviewEmployee = reviewEmployee;
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: '該人員無覆核權限',
            });
          }
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '條碼未找到人員',
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// RxCheckBarcode.vue?71c6bbc6